export const defaultInputTheme = {
	label: 'hsl(0, 0%, 30%)',
	hint: 'hsl(0, 0%, 40%)',
	content: 'hsl(0, 0%, 0%)',
	contentDisabled: 'hsl(0, 0%, 50%)',
	contentLoading: 'hsl(0, 0%, 50%)',
	placeholder: 'hsl(0, 0%, 50%)',
	placeholderError: 'hsl(0, 83%, 70%)',
	focusOutline: 'hsla(134, 34%, 73%, 0.9)',

	background: 'hsl(0, 0%, 100%)',
	backgroundDisabled: 'hsl(0, 0%, 90%)',
	backgroundHover: 'hsla(134, 34%, 83%, 0.1)',
	backgroundReadOnly: 'hsl(0, 0%, 90%)',
	backgroundError: 'hsl(0, 80%, 90%)',
	backgroundErrorHover: 'hsl(0, 80%, 95%)',

	border: 'hsl(0, 0%, 70%)',
	borderHover: 'hsl(134, 69%, 21%)',
	borderError: 'hsl(0, 80%, 51%)',
	borderOutlineHover: 'hsl(134, 69%, 21%)',
	borderOutlineError: 'hsl(0, 80%, 51%)',

	chipBackground: 'hsl(0, 0%, 90%)',
	buttonChipClear: 'hsl(0, 0%, 40%)',
	buttonChipClearHover: 'hsl(0, 80%, 51%)',
	buttonChipClearBackground: 'transparent',
	buttonChipClearBackgroundHover: 'hsl(0, 80%, 90%)',

	buttonClear: 'hsl(0, 0%, 40%)',
	buttonClearHover: 'hsl(0, 80%, 51%)',
	buttonClearBackground: 'transparent',
	buttonClearBackgroundHover: 'hsla(0, 80%, 51%, 0.2)',
	buttonIcon: 'hsl(0, 0%, 40%)',
	buttonIconHover: 'hsl(134, 69%, 21%)',
	buttonIconBackground: 'transparent',
	buttonIconBackgroundHover: 'hsla(134, 34%, 73%, 0.5)',
	buttonIconDisabled: 'hsl(0, 0%, 50%)',

	loadingIndicator: 'hsl(0, 0%, 30%)',
	loadingIndicatorBackground: 'hsl(0, 0%, 90%)',

	menuIndicator: 'hsl(0, 0%, 70%)',
	menuIndicatorActive: 'hsl(134, 69%, 21%)',
	menuIndicatorError: 'hsl(0, 0%, 40%)',
	menuIndicatorErrorActive: 'hsl(0, 80%, 51%)',
	menuSeparator: 'hsl(0, 0%, 80%)',
	menuSeparatorError: 'hsl(0, 80%, 51%)',

	menuOption: 'hsl(0, 0%, 0%)',
	menuOptionBackground: 'hsl(0, 0%, 100%)',
	menuOptionBackgroundDisabled: 'hsl(0, 0%, 80%)',
	menuOptionBackgroundHighlighted: 'hsla(134, 34%, 73%, 0.5)',
	menuOptionBackgroundHighlightedDisabled: 'hsl(0, 0%, 70%)',
	menuOptionBackgroundSelected: 'hsla(134, 34%, 73%, 0.2)',
	menuOptionBackgroundSelectedDisabled: 'hsl(0, 0%, 70%)',
	menuOptionBackgroundHover: 'hsla(134, 34%, 73%, 0.5)',
	menuOptionBackgroundHoverDisabled: 'hsl(0, 0%, 50%)',
	menuOptionCheckMark: 'hsl(134, 69%, 21%)',
	menuBackground: 'hsl(0, 0%, 100%)',
	menuBorder: 'hsl(0, 0%, 80%)',
	menuEmpty: 'hsl(0, 0%, 40%)',

	toggle: 'hsl(0, 0%, 100%)',
	toggleDisabled: 'hsl(0, 0%, 100%)',
	toggleReadOnly: 'hsl(0, 0%, 100%)',
	toggleBackground: 'hsl(0, 0%, 80%)',
	toggleBackgroundHover: 'hsl(134, 34%, 73%)',
	toggleBackgroundDisabled: 'hsl(0, 0%, 50%)',
	toggleBackgroundReadOnly: 'hsl(0, 0%, 90%)',
	toggleBackgroundChecked: 'hsl(134, 69%, 21%)',
	toggleBackgroundCheckedReadOnly: 'hsla(134, 34%, 73%, 0.5)',
	toggleBackgroundCheckedHover: 'hsla(134, 69%, 21%, 0.8)',

	errorBox: 'hsl(0, 0%, 100%)',
	errorBoxBackground: 'hsl(0, 80%, 51%)',
	errorBoxIcon: 'hsl(0, 0%, 100%)',

	changeIndicator: 'hsl(30, 89%, 49%)',
	changeIndicatorError: 'hsl(0, 80%, 51%)',
}
